import React from 'react';
import { Button, Card, Text } from '@fragments';
import { IconCreditCard } from '@tabler/icons-react';
import CardBrand from '../../../../components/CardBrand';
import './styles.scss';

const brandName = brand => (brand ? brand.charAt(0).toUpperCase() + brand.slice(1) : '');

// The subscription's default card (brand and last 4 — nothing else reaches the core). It is
// changed in Stripe's portal, which comes back to this page. Packs are paid per purchase, so
// without a subscription there is no card on file.
export default function PaymentMethodCard({ studio: s, page }) {
  const { t } = s;
  const p = s.payments;
  const card = page.subscription?.payment_method;
  return <Card split className="studio-payment-method">
    <div className="studio-payment-method__head">
      <Text.subheading contrast={6} left={<IconCreditCard />}>{t('billingCardEyebrow')}</Text.subheading>
      {page.live && <Button variant="rounded" color="overlay" size="small" onClick={page.openPortal}>{t(card ? 'changeCard' : 'billingAddCard')}</Button>}
    </div>
    {card ? <div className="studio-payment-method__card">
      <CardBrand brand={card.brand} />
      <div className="studio-payment-method__text">
        <Text.label contrast={9}>{t('billingCardLabel', { brand: brandName(card.brand), last4: card.last4 })}</Text.label>
        <Text.caption contrast={6}>{t('billingCardHint', { plan: t(`planName_${p.plan}`) })}</Text.caption>
      </div>
    </div> : <div className="studio-payment-method__text">
      <Text.label contrast={9}>{t('billingNoCard')}</Text.label>
      <Text.caption contrast={6}>{t('billingNoCardHint')}</Text.caption>
    </div>}
  </Card>;
}
